const Flows = {
    ORDER_AHEAD: "ORDER_AHEAD",
    TAKE_AWAY: "TAKE_AWAY",
    OPEN_TABLE: "OPEN_TABLE",
    DELIVERY: "DELIVERY",
};

export {
    Flows
}